import React from 'react'
import { useTranslation } from 'react-i18next'
import Table from './components/Table'
import VariablesContextProvider from './contexts/variablesContext'
import CurrentUserContextProvider from 'contexts/currentUserContext'
import AbilityContextProvider from 'contexts/abilityContext'

const Formalities = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <VariablesContextProvider>
      <CurrentUserContextProvider>
        <AbilityContextProvider>
          <div>
            <h1>{t('legalFormalities:title')}</h1>
            <Table />
          </div>
        </AbilityContextProvider>
      </CurrentUserContextProvider>
    </VariablesContextProvider>
  )
}

export default Formalities
